import React, { Component } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../store';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ClientePocForm from './upsert/components/ClientePocForm';
import ResponseError from '../../shared/responses/ResponseError';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';
import ClientePacsForm from './upsert/components/ClientePacsForm';
import ResponseResult from '../../shared/responses/ResponseResult';
import ClienteConfigForm from './upsert/components/ClienteConfigForm';
import ClienteServicesForm from './upsert/components/ClienteServicesForm';
import ClienteFiscalInfoForm from './upsert/components/ClienteFiscalInfoForm';

class ClientesEdit extends Component {
  state = {};
  steps = [
    {
      number: 1,
      key: 'invite-info',
      done: false,
    },
    {
      number: 2,
      key: 'poc',
      done: true,
    },
    {
      number: 3,
      key: 'services',
      done: true,
    },
    {
      number: 4,
      key: 'pacs',
      done: true,
      isValid: false,
    },
    {
      number: 5,
      key: 'config',
      isValid: true,
      done: true,
    },
  ];

  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      data: !!data.id ? { ...data } : { id, servicios: {} },
      steps: [...this.steps],
    };

    props.upsertAction.setInitialState(this.state);
  }

  componentDidMount() {
    const { data = {} } = this.state;

    if (!data.id) {
      return this.props.history.push(`/admin/clientes/${data.id}/info`);
    }
  }

  componentWillUnmount() {
    this.props.infoAction.reset();
    this.props.upsertAction.reset();
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.upsertAction.setPartialState({
        error: undefined,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    const { result } = this.props.upsert;

    if (!!result) {
      this.props.listAction.highlight(result.data);
    }

    this.props.history.replace('/admin/clientes');
  };

  handleOnConfirm = async () => {
    const { data } = this.props.upsert;
    const keys = Object.keys(data);

    let body = {};

    for (const key of keys) {
      if (data[key] !== null) {
        body[key] = data[key];
      }
    }

    delete body.id;
    delete body.status;

    const newBody = {
      ...body,
      pacs: data.pacs.map((item) => item.value),
    };

    await this.props.upsertAction.upsert(newBody, data.id);
  };

  handleOnDataChange = (event) => {
    this.props.upsertAction.setStepDataChange(event);
  };

  renderError = () => {
    const { error } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props.upsert;

    return (
      <div className="result-container">
        <ResponseResult
          title="Actualización exitosa"
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data = {}, steps, isValid, busy, error, result, fetching } = this.props.upsert;

    if (fetching) {
      return <Loading />;
    }

    return (
      <>
        {!!error && this.renderError()}

        {!!result && this.renderResult()}

        <PageHeader
          to="/admin/clientes"
          text="Clientes"
        />

        <h5>{data.nombre_comercial}</h5>

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">DATOS FISCALES</strong>
            </div>
            <ClienteFiscalInfoForm
              data={data}
              step={steps[0]}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">CONTACTO</strong>
            </div>

            <ClientePocForm
              data={data}
              step={steps[1]}
              autoFocus={false}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>
        </Row>

        {Guardian.allows('cliente.editar.servicios') && (
          <>
            <Row>
              <Col>
                <div className="py-3">
                  <strong className="text-info">CONFIGURACIONES</strong>
                </div>

                <ClienteConfigForm
                  data={data}
                  step={steps[4]}
                  onFormDataChange={this.handleOnDataChange}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="py-3">
                  <strong className="text-info">SERVICIOS</strong>
                </div>

                <ClienteServicesForm
                  data={data}
                  step={steps[2]}
                  onFormDataChange={this.handleOnDataChange}
                />
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">PACS</strong>
            </div>

            <ClientePacsForm
              data={data}
              step={steps[3]}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>
        </Row>

        <Row className="pb-4">
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <PopConfirm
              text="Cancelar actualización de datos?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
              >
                Cancelar
              </Button>
            </PopConfirm>{' '}
            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnConfirm}
            >
              {busy === true ? 'Guardando...' : 'Guardar'}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return {
    info: store.admin.clientes.info,
    list: store.admin.clientes.list,
    upsert: store.admin.clientes.upsert,
  };
};

const mapActions = (actions) => {
  return {
    infoAction: actions.admin.clientes.info,
    upsertAction: {
      ...actions.admin.clientes.upsert,
      setInitialState: (data) => {
        const newData = {
          ...data,
          data: {
            ...data.data,
            tipo_integracion: data.data?.config?.tipo_integracion,
            pacs: data.data?.config?.pacs.map((item) => {
              return { label: item, value: item };
            }),
          },
        };

        return actions.admin.clientes.upsert.setPartialState(newData);
      },
    },
    listAction: actions.admin.clientes.list,
  };
};

export default connect(useStore, mapState, mapActions)(ClientesEdit);
